export default __webpack_public_path__ + "static/media/english.74737f1f.mp4";